import axios from "axios";
import React, { useEffect, useState } from "react";
import paginationFactory, {
	PaginationProvider,
} from "react-bootstrap-table2-paginator";
import { useHistory } from "react-router-dom";
import { faPlus } from "@fortawesome/free-solid-svg-icons";
import { Table } from "../../components/CustomPaginations";
import overlayFactory from "react-bootstrap-table2-overlay";
import {
	dateCol,
	statusColor,
	tableStyle,
	timeCol,
	TrimString,
} from "../../components/TableStyle";
import { UserConsumer } from "../../UserContext";
import Header from "../../components/Header";
import SubHeader from "../../components/SubHeader";
import { OffsiteHours_API } from "./OffsiteHours_API";
import FilterationBar from "./common/FilterationBar";
import {
	GlobalPaginationSize,
	getPaginationSizeOnRole,
} from "../../components/GlobalPaginationSize";
import { Routes } from "../../configurations/config";
import ActionFormatter from "./common/ActionFormatter";

function OffsiteWorkHours() {
	let token,
		empDesignation,
		joiningDate = null;
	let history = useHistory();

	const months = [
		{ value: 0, label: "All" },
		{ value: 1, label: "January" },
		{ value: 2, label: "February" },
		{ value: 3, label: "March" },
		{ value: 4, label: "April" },
		{ value: 5, label: "May" },
		{ value: 6, label: "June" },
		{ value: 7, label: "July" },
		{ value: 8, label: "August" },
		{ value: 9, label: "September" },
		{ value: 10, label: "October" },
		{ value: 11, label: "November" },
		{ value: 12, label: "December" },
	];
	const status = [
		{ value: 0, label: "All" },
		{ value: 1, label: "Pending Requests" },
		{ value: 2, label: "Rejected Requests" },
		{ value: 3, label: "Approved Requests" },
	];

	const [yearsList, setYearsList] = useState([]);

	let date = new Date();
	let currentYear = date.getFullYear();
	const [selectedMonth, setSelectedMonth] = useState(
		sessionStorage.getItem("MyOffsiteFilter")
			? JSON.parse(sessionStorage.getItem("MyOffsiteFilter"))[1]
				? JSON.parse(sessionStorage.getItem("MyOffsiteFilter"))[1]
				: months[0]
			: months[0]
	);
	const [selectedYear, setSelectedYear] = useState(
		sessionStorage.getItem("MyOffsiteFilter")
			? JSON.parse(sessionStorage.getItem("MyOffsiteFilter"))[0]
				? JSON.parse(sessionStorage.getItem("MyOffsiteFilter"))[0]
				: {
						value: date.getFullYear(),
						label: date.getFullYear(),
				  }
			: {
					value: date.getFullYear(),
					label: date.getFullYear(),
			  }
	);
	const defaultSorted = [
		{
			dataField: "requestDate",
			order: "desc",
		},
	];
	const [sortBy, setSortBy] = useState(defaultSorted[0]);
	const [selectedStatus, setSelectedStatus] = useState(
		sessionStorage.getItem("MyOffsiteFilter")
			? JSON.parse(sessionStorage.getItem("MyOffsiteFilter"))[2]
				? JSON.parse(sessionStorage.getItem("MyOffsiteFilter"))[2]
				: status[0]
			: status[0]
	);
	const [tokenHeader, setTokenHeader] = useState(null);
	const [pageNum, setPageNum] = useState(1);
	const [pagerData, setPagerData] = useState(null);
	const [isLoading, setIsLoading] = useState(true);
	const [offsiteHoursData, setOffsiteHoursData] = useState([]);
	const [numberOfItemsPerPage, setNumberOfItemsPerPage] = useState(
		GlobalPaginationSize.defaultPaginationSize
	);

	const customFormatter = (row) => (
		<ActionFormatter
			requestId={row.requestId}
			supervisorStatus={row.supervisorStatus}
		/>
	);
	const getColumns = [
		{
			dataField: "requestDate",
			text: "Worked Date",
			sort: true,
			formatter: dateCol,
		},
		{
			dataField: "requestDay",
			text: "Worked Day",
			sort: true,
		},
		
		{
			dataField: "requestExpiryDate",
			text: "Compensation Expiry Date",
			sort: true,
			formatter: (cell, row) => {
				
			  if (!row.isApprovedCompensationLog) {
				return "NA"; // Set requestExpiryDate to null
			  } else {
				return dateCol(cell, row); // Use the original formatter if requestDay is not empty
			  }
			},
		  },
		{
			dataField: "startTime",
			text: "Start Time",
			sort: true,
			formatter: timeCol,
		},
		{
			dataField: "hoursWorked",
			text: "Work Hours",
			sort: true,
			formatter: (hoursWorked) => {
				let worked = hoursWorked.split(":");
				return worked[0] + " Hr " + worked[1] + " Min";
			},
		},

		{
			dataField: "type",
			text: "Type",
			sort: true,
			formatter: TrimString,
		},
		{
			dataField: "supervisorStatus",
			text: "Status",
			sort: true,
			formatter: (status) => {
				return status === "Pending"
					? "Pending"
					: status === "InProgress"
					? "Pending"
					: status === "Approved"
					? "Approved"
					: status === "Rejected"
					? "Rejected"
					: "Pending";
			},
			style: statusColor,
		},
		{
			dataField: "employeeComments",
			text: "Work Reason",
			formatter: TrimString,
		},
		{
			dataField: "action",
			text: "Action",
			formatter: (cell, row) => customFormatter(row),
		},
	];
	useEffect(() => {
		const pageSize = getPaginationSizeOnRole(empDesignation);
		setNumberOfItemsPerPage(pageSize);

		//To auto start from joining date till current year
		const list = [];
		do {
			list.unshift({ value: joiningDate, label: joiningDate.toString() });
			joiningDate++;
		} while (joiningDate != currentYear + 1);
		setYearsList(list);

		const headers = {
			Authorization: `Bearer ${token}`,
		};
		axios
			.get(
				`${OffsiteHours_API.GetOffsiteHoursList}PageNumber=${pageNum}&PageSize=${pageSize}&Status=${selectedStatus.value}&Month=${selectedMonth.value}&Year=${selectedYear.value}&SortBy=${sortBy.dataField}_${sortBy.order}`,
				{ headers: headers }
			)
			.then((res) => {
				if (res.status === 200) {
					setIsLoading(false);
					setPagerData(JSON.parse(res.headers["x-pagination"]));
					setOffsiteHoursData(res.data.offSiteHours);
				}
			});

		setTokenHeader(headers);
	}, []);

	const updateTableData = (year, month, status) => {
		//call api on table updation

		setIsLoading(true);
		axios
			.get(
				`${
					OffsiteHours_API.GetOffsiteHoursList
				}PageNumber=${1}&PageSize=${numberOfItemsPerPage}&Status=${status}&Month=${month}&Year=${year}&SortBy=${
					sortBy.dataField
				}_${sortBy.order}`,
				{
					headers: tokenHeader,
				}
			)
			.then((res) => {
				if (res.status === 200) {
					setIsLoading(false);
					setPageNum(1);
					setPagerData(JSON.parse(res.headers["x-pagination"]));
					setOffsiteHoursData(res.data.offSiteHours);
				}
			});
	};

	const receiveData = (PageSize) => {
		//call api on table page size change
		setIsLoading(true);
		axios
			.get(
				`${OffsiteHours_API.GetOffsiteHoursList}PageNumber=1&PageSize=${PageSize}&SortBy=${sortBy.dataField}_${sortBy.order}&Status=${selectedStatus.value}&Month=${selectedMonth.value}&Year=${selectedYear.value}`,
				{
					headers: tokenHeader,
				}
			)
			.then((res) => {
				if (res.status === 200) {
					setIsLoading(false);
					setPageNum(1);
					setNumberOfItemsPerPage(PageSize);
					setPagerData(JSON.parse(res.headers["x-pagination"]));
					setOffsiteHoursData(res.data.offSiteHours);
				}
			});
	};
	const handleTableChange = (type, { page, sortOrder, sortField }) => {
		//call api on table sorting and pagination
		setIsLoading(true);
		let getData = false;
		let apiURL = "";
		if (type === "sort") {
			apiURL = `${OffsiteHours_API.GetOffsiteHoursList}PageSize=${numberOfItemsPerPage}&PageNumber=${page}&SortBy=${sortField}_${sortOrder}&Status=${selectedStatus.value}&Month=${selectedMonth.value}&Year=${selectedYear.value}`;
			setSortBy({ dataField: sortField, order: sortOrder });
			getData = true;
		} else if (type === "pagination") {
			apiURL = `${OffsiteHours_API.GetOffsiteHoursList}PageSize=${numberOfItemsPerPage}&PageNumber=${page}&SortBy=${sortBy.dataField}_${sortBy.order}&Status=${selectedStatus.value}&Month=${selectedMonth.value}&Year=${selectedYear.value}`;
			getData = true;
		}
		if (getData) {
			axios
				.get(apiURL, {
					headers: tokenHeader,
				})
				.then((res) => {
					if (res.status === 200) {
						setIsLoading(false);
						setPageNum(page);
						setPagerData(JSON.parse(res.headers["x-pagination"]));
						setOffsiteHoursData(res.data.offSiteHours);
					}
				});
		}
	};
	const storeFiltersStates = (value, property) => {
		let obj = [];
		if (sessionStorage.getItem("MyOffsiteFilter"))
			obj = JSON.parse(sessionStorage.getItem("MyOffsiteFilter"));
		if (property === "year") obj[0] = value;
		else if (property === "month") obj[1] = value;
		else if (property === "status") obj[2] = value;
		sessionStorage.setItem("MyOffsiteFilter", JSON.stringify(obj));
	};
	const rowEvents = {
		onClick: (e, row) => {
			history.push({
				pathname: `/OffsiteWorkHours/${row.requestId}`,
				state: {
					itemStatus: row.supervisorStatus,
				},
			});
		},
	};

	return (
		<UserConsumer>
			{(userDetails) => {
				token = userDetails.token;
				empDesignation = userDetails.designation;
				joiningDate = userDetails.empJoinedOn.split("-")[0];
				return (
					<>
						<div className="container-fluid pl-3 pr-3">
							<Header
								title="Offsite Work Hours"
								headerBorder={true}
							/>

							<SubHeader
								btnTitle="Create New"
								icon={faPlus}
								linkTo={Routes.OffsiteWorkHoursRequest}
							/>

							<FilterationBar
								months={months}
								years={yearsList}
								selectedYear={selectedYear}
								onYearChange={(value) => {
									setSelectedYear(value);
									storeFiltersStates(value, "year");
									updateTableData(
										value.value,
										selectedMonth.value,
										selectedStatus.value
									);
								}}
								selectedMonth={selectedMonth}
								onMonthChange={(value) => {
									setSelectedMonth(value);
									storeFiltersStates(value, "month");
									updateTableData(
										selectedYear.value,
										value.value,
										selectedStatus.value
									);
								}}
								status={status.sort((a, b) =>
									a.label.localeCompare(b.label)
								)}
								selectedStatus={selectedStatus}
								onStatusChange={(value) => {
									setSelectedStatus(value);
									storeFiltersStates(value, "status");
									updateTableData(
										selectedYear.value,
										selectedMonth.value,
										value.value
									);
								}}
							/>

							{/*Table with pagination*/}
							<PaginationProvider
								pagination={paginationFactory({
									custom: true,
									totalSize: pagerData
										? pagerData.TotalCount
										: 0,
									page: pageNum,
									sizePerPage: numberOfItemsPerPage,
									paginationSize: numberOfItemsPerPage,
								})}
							>
								{({
									paginationProps,
									paginationTableProps,
								}) => {
									return (
										<Table
											inputValue={""}
											keyField={"token"}
											columns={getColumns}
											items={offsiteHoursData}
											tableStyle={tableStyle}
											paginationProps={paginationProps}
											paginationTableProps={
												paginationTableProps
											}
											onTablePageChange={
												handleTableChange
											}
											defaultSorted={defaultSorted}
											showFeedback={false}
											tableLoader={isLoading}
											SearchBar={() => {
												return null;
											}}
											pagerData={pagerData}
											receiveData={(PageSize) => {
												receiveData(PageSize);
											}}
											loading={isLoading}
											striped={false}
											overlay={overlayFactory({
												spinner: true,
												styles: {
													overlay: (base) => ({
														...base,
														background:
															"rgba(255, 0, 0, 0.5)",
													}),
												},
											})}
											rowEvents={rowEvents}
										/>
									);
								}}
							</PaginationProvider>
						</div>
					</>
				);
			}}
		</UserConsumer>
	);
}

export default OffsiteWorkHours;
